import React, { useState, useContext, useEffect } from 'react';
import styled, { useTheme } from 'styled-components';
import OutsideClickHandler from 'react-outside-click-handler';
import FocusTrap from 'focus-trap-react';
import { DealerSearchContext } from '@repo/contexts/DealerSearchContext';
import { useUiComponentsInternationalContext } from '@repo/static-translations';
import { MdClose } from 'react-icons/md';
// eslint-disable-next-line import/no-cycle
import DealerSearch from './DealerSearch';

const Modal = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 99999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.15s ease-in-out;
`;

const SearchWrapper = styled.div`
  min-width: 20rem;
  max-width: 25rem;
  width: 100%;
  height: 100vh;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  transition: all 0.25s ease-out;
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  transform: translateX(${({ visible }) => (visible ? '0' : '-100%')});
  padding: 1rem;
  overflow-y: auto;
`;

const Header = styled.div`
  display: flex;
  margin-bottom: 1rem;
  h2 {
    font-size: 2rem;
    flex: 1;
    color: ${({ theme }) => theme.colors.defaultFont};
  }
  button {
    padding: 0;
    padding-left: 1rem;
    margin: 0;
    border: none;
    background: none;
    cursor: pointer;
  }
`;

function DealerSearchFlyout() {
  const { dealerSearchActive, setDealerSearchActive, dealerSearchDisplayMode } =
    useContext(DealerSearchContext);

  const { tt } = useUiComponentsInternationalContext();

  const theme = useTheme();
  const iconColor = theme.colors.brandPrimary;

  const [modalVisible, setModalVisible] = useState(dealerSearchActive);
  const [sliderVisible, setSliderVisible] = useState(dealerSearchActive);

  useEffect(() => {
    if (dealerSearchActive) {
      setModalVisible(true);
      setSliderVisible(true);
    }
  }, [dealerSearchActive]);

  useEffect(() => {
    if (!sliderVisible) {
      setTimeout(() => {
        setModalVisible(false);
      }, 125); // allow time for transition to happen
    }
  }, [sliderVisible]);

  useEffect(() => {
    if (!modalVisible) {
      setTimeout(() => {
        setDealerSearchActive(false);
      }, 125); // allow time for transition to happen
    }
  }, [modalVisible, setDealerSearchActive]);

  return (
    dealerSearchActive && (
      <Modal visible={modalVisible}>
        <OutsideClickHandler
          onOutsideClick={() => {
            setSliderVisible(false);
          }}
        >
          <FocusTrap
            focusTrapOptions={{
              fallbackFocus: '.focus-trap-fallback',
            }}
          >
            <SearchWrapper visible={sliderVisible}>
              <Header>
                <h2>{tt(s => s.dealerCommon.findDealerHeader)}</h2>
                <button
                  type="button"
                  onClick={() => {
                    setSliderVisible(false);
                  }}
                  aria-label={tt(
                    s => s.dealerCommon.closeDealerSearchAriaLabel
                  )}
                >
                  <MdClose size={36} fill={iconColor} />
                </button>
              </Header>
              <DealerSearch displayMode={dealerSearchDisplayMode} />
              <div className="focus-trap-fallback" tabIndex="-1" />
            </SearchWrapper>
          </FocusTrap>
        </OutsideClickHandler>
      </Modal>
    )
  );
}

export default DealerSearchFlyout;
